import { getParentReturnIds } from "./ReturnIdDropdown.service";
import type { DestinationReturnIdOption, StatusColors } from "./ReturnIdDropdown.types";

export const getStatusColors = (status?: string): StatusColors => {
  if (!status) return { dot: "#9ca3af", bg: "#f3f4f6", border: "#e5e7eb", fg: "#374151" };
  const normalizedStatus = status.toLowerCase();

  if (normalizedStatus.includes("complet") || normalizedStatus.includes("approv") || normalizedStatus.includes("verif")) {
    return { dot: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0", fg: "#15803d" };
  }

  if (normalizedStatus.includes("prep") || normalizedStatus.includes("progress") || normalizedStatus.includes("process")) {
    return { dot: "#f59e0b", bg: "#fffbeb", border: "#fde68a", fg: "#92400e" };
  }

  if (normalizedStatus.includes("error") || normalizedStatus.includes("fail")) {
    return { dot: "#ef4444", bg: "#fef2f2", border: "#fecaca", fg: "#b91c1c" };
  }

  return { dot: "#9ca3af", bg: "#f3f4f6", border: "#e5e7eb", fg: "#374151" };
};

export const formatReturnLastUpdated = (value?: string) => {
  if (!value) return "not available";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const mapToDropdownOptions = (returnIds: any[]): DestinationReturnIdOption[] =>
  returnIds.map((item: any) => ({
    label: item.ReturnId,
    value: item.ReturnId,
    lastUpdated: item.ReturnLastUpdatedDate,
    status: item.ReturnStatus,
  }));

const destinationReturnOptionsCache = new Map<string, Promise<DestinationReturnIdOption[]>>();

export const getDestinationReturnOptions = (
  clientMasterId: string,
  parentClientMasterId: string,
): Promise<DestinationReturnIdOption[]> => {
  if (!clientMasterId || !parentClientMasterId) return Promise.resolve([]);

  const cacheKey = `${clientMasterId}:${parentClientMasterId}`;
  const cached = destinationReturnOptionsCache.get(cacheKey);
  if (cached) return cached;

  const request = getParentReturnIds(clientMasterId, parentClientMasterId)
    .then(mapToDropdownOptions)
    .catch((error) => {
      destinationReturnOptionsCache.delete(cacheKey);
      throw error;
    });

  destinationReturnOptionsCache.set(cacheKey, request);
  return request;
};
